var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div ng-click=\"_modal.close($event)\" class=\"modal\">\n  <div ng-click=\"_modal.close($event)\" class=\"modal-center\">\n    <div class=\"modal-window confirm\">\n      <div class=\"modal-body\">\n        <h3>{{ title }}</h3>\n        <p>{{ body }}</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" ng-click=\"_modal.close()\" class=\"cancel\">{{ t('cCancel') }}</button>\n        <button type=\"submit\" ng-click=\"_modal.onConfirm()\" autofocus class=\"action\">{{ title }}</button>\n      </div>\n    </div>\n  </div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/confirm.jade
 ** module id = 66
 ** module chunks = 1
 **/